/**
 * Resource API
 * # Introduction Resource API allows you to query the resources in the pools on KAS.
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

const ApiClient = require('../../ApiClient')

/**
 * The ResourceResponse model module.
 * @class ResourceResponse
 * @version 1.0
 */
class ResourceResponse {
    /**
     * Constructs a new <code>ResourceResponse</code>.
     * @alias ResourceResponse
     * @class
     * @param accountId {String} KAS account ID
     * @param chainId {Number} Chain ID
     * @param createdAt {Number} Creation time (in sec.)
     * @param _default {Boolean} Returns whether default resource is used
     * @param krn {String} KAS resource name
     * @param resourceId {String} Resource ID
     * @param resourceType {String} Resource type
     * @param serviceId {String} Service ID
     */

    constructor(accountId, chainId, createdAt, _default, krn, resourceId, resourceType, serviceId) {
        this.accountId = accountId
        this.chainId = chainId
        this.createdAt = createdAt
        this.default = _default
        this.krn = krn
        this.resourceId = resourceId
        this.resourceType = resourceType
        this.serviceId = serviceId
    }

    /**
     * Constructs a <code>ResourceResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {ResourceResponse} obj Optional instance to populate.
     * @return {ResourceResponse} The populated <code>ResourceResponse</code> instance.
     * @memberof ResourceResponse
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ResourceResponse()

            if (data.hasOwnProperty('accountId')) {
                obj.accountId = ApiClient.convertToType(data.accountId, 'String')
            }
            if (data.hasOwnProperty('chainId')) {
                obj.chainId = ApiClient.convertToType(data.chainId, 'Number')
            }
            if (data.hasOwnProperty('createdAt')) {
                obj.createdAt = ApiClient.convertToType(data.createdAt, 'Number')
            }
            if (data.hasOwnProperty('default')) {
                obj.default = ApiClient.convertToType(data.default, 'Boolean')
            }
            if (data.hasOwnProperty('krn')) {
                obj.krn = ApiClient.convertToType(data.krn, 'String')
            }
            if (data.hasOwnProperty('resourceId')) {
                obj.resourceId = ApiClient.convertToType(data.resourceId, 'String')
            }
            if (data.hasOwnProperty('resourceType')) {
                obj.resourceType = ApiClient.convertToType(data.resourceType, 'String')
            }
            if (data.hasOwnProperty('serviceId')) {
                obj.serviceId = ApiClient.convertToType(data.serviceId, 'String')
            }
        }
        return obj
    }
}

/**
 * KAS account ID
 * @type {String}
 * @memberof ResourceResponse
 */
ResourceResponse.prototype.accountId = undefined
/**
 * Chain ID
 * @type {Number}
 * @memberof ResourceResponse
 */
ResourceResponse.prototype.chainId = undefined
/**
 * Creation time (in sec.)
 * @type {Number}
 * @memberof ResourceResponse
 */
ResourceResponse.prototype.createdAt = undefined
/**
 * Returns whether default resource is used
 * @type {Boolean}
 * @memberof ResourceResponse
 */
ResourceResponse.prototype.default = undefined
/**
 * KAS resource name
 * @type {String}
 * @memberof ResourceResponse
 */
ResourceResponse.prototype.krn = undefined
/**
 * Resource ID
 * @type {String}
 * @memberof ResourceResponse
 */
ResourceResponse.prototype.resourceId = undefined
/**
 * Resource type
 * @type {String}
 * @memberof ResourceResponse
 */
ResourceResponse.prototype.resourceType = undefined
/**
 * Service ID
 * @type {String}
 * @memberof ResourceResponse
 */
ResourceResponse.prototype.serviceId = undefined

module.exports = ResourceResponse
